import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Globals } from '../globals';
import { HttpInterceptor } from '../interceptors/http-interceptor.service';
import { PermisoService } from './permiso.service';
import { Entidad } from '../interfaces/entidad';
import { GeneralService } from './general.service';

@Injectable()
export class ProspectoService {
    constructor(
        private http: HttpInterceptor,
        private globals: Globals,
        private general: GeneralService,
        private permisoService: PermisoService
    ) { }

    crearProspecto(entidad: Entidad): Observable<any> {
        return this.permisoService.getPermisoAction('PROSPECTO-CREAR')
            .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            entidad: entidad
                        })
                    );
            })
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                (respuesta: Response) => respuesta.json());
    }

    editarProspecto(entidad: Entidad): Observable<any> {
        return this.permisoService.getPermisoAction('PROSPECTO-EDITAR')
            .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            entidad: entidad
                        })
                    );
            })
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                (respuesta: Response) => respuesta.json());
    }

    eliminarProspecto(IdEntidad: number): Observable<any> {
        return this.permisoService.getPermisoAction('PROSPECTO-ELIMINAR')
            .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            IdEntidad: IdEntidad
                        })
                    );
            })
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                (respuesta: Response) => respuesta.json());
    }

    getProspectos(
        paginado: any = {
            page: 0,
            pageSize: 10
        },
        orden: any = {
            sort: 'razonSocial',
            order: 'asc'
        },
        filtros: any = {
            generico: ''
        }): Observable<any> {
        // getProspectos solo necesita el observable de this.http.post, sin embargo este observable depende del anterior
        // que sabe a que controller/action debe llamar una vez que los permisos fueron obtenidos del servidor.
        return this.permisoService.getPermisoAction('PROSPECTO-VER')
            .switchMap((controllerAction) => {
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            paginado: paginado,
                            orden: orden,
                            filtros: filtros
                        })
                    )
                    .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                        (respuesta: Response) => respuesta.json()
                    );
            });
    }

    esCliente(IdEntidad: number): Observable<any> {
        return this.permisoService.getPermisoAction('PROSPECTO-ES-CLIENTE')
            .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            IdEntidad: IdEntidad
                        })
                    );
            })
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                (respuesta: Response) => respuesta.json());
    }
}